import React, { useEffect, useRef } from "react";

/**
 * Matrix-style digital rain effect for Sofia's background
 * Displays falling code/symbols in gold color
 */
export default function MatrixRain() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Matrix characters - Arabic + English + Numbers for Dubai/tech feel
    const matrix = "ابجدهوزحطيكلمنسعفصقرشتثخذضظغ0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const chars = matrix.split("");

    const fontSize = 14;
    const columns = canvas.width / fontSize;
    const drops = [];

    for (let i = 0; i < columns; i++) {
      drops[i] = Math.random() * -100;
    }

    const draw = () => {
      // Semi-transparent black for trail effect
      ctx.fillStyle = "rgba(11, 32, 39, 0.05)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Gold text with glow
      ctx.fillStyle = "#C9A86A";
      ctx.shadowBlur = 8;
      ctx.shadowColor = "#C9A86A";
      ctx.font = `${fontSize}px "Courier New", monospace`;

      for (let i = 0; i < drops.length; i++) {
        const text = chars[Math.floor(Math.random() * chars.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;

        ctx.fillText(text, x, y);

        // Reset drop to top randomly
        if (y > canvas.height && Math.random() > 0.95) {
          drops[i] = 0;
        }

        drops[i]++;
      }
    };

    const interval = setInterval(draw, 35);

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none opacity-30"
      style={{ zIndex: 0 }}
    />
  );
}
